<div class="bg-[#0A0E1F] text-white font-sans pt-16 pb-10 px-6 md:px-12 lg:px-20">
  <div class="max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 items-center">
    <div class="h-full flex order-2 lg:order-1">
      <div class="relative image-accent">
        <img src="https://cmax.pages.dev/assets/landing-page/About.png" alt="Gaming Illustration"
          class="w-full h-full object-cover border_style" />
      </div>
    </div>

    <div class="h-full flex flex-col justify-between text-center lg:text-start order-1 lg:order-2">
      <h3 class="font-libre font-bold text-[22px] leading-[27px]">
        <span class="text-[#19E4E0] border-b-2 border-[#19E4E0] pb-[0.05rem]">About Us</span>
        <span class="text-white"> Elite Gaming</span>
      </h3>

      <h1 class="text-2xl md:text-3xl font-bold mt-2">
        Forging Legends in the
        <span class="text-white">Gaming Universe</span>
      </h1>

      <p class="text-gray-300 leading-relaxed mb-6">
        <span class="text-[#19E4E0] font-semibold">Elite Gaming</span>
        brings you the thrill of competitive arcade fun in a safe and entertaining
        online experience. Our mission is to deliver exciting games, fair play,
        and astonishing in-game achievements for every player.
      </p>

      <p class="text-gray-400 leading-relaxed mb-6">
        From classic spins to modern gaming, our platform is built to give you an
        authentic, immersive arcade environment, anywhere.
      </p>

      <p class="text-gray-400 leading-relaxed mb-10">
        We’re passionate about creating a secure, engaging, and rewarding gaming
        community where everyone can enjoy the excitement of leveling up and climbing the leaderboards.
      </p>

      <div
        class="flex justify-center lg:justify-between items-center gap-6 sm:gap-[6rem] md:gap-[10rem] lg:gap-[10rem] flex-nowrap overflow-x-auto scrollbar-hide">
        <div *ngFor="let item of stats" class="flex flex-col items-center text-center shrink-0">
          <h2
            class="font-extrabold text-white text-[1.8rem] sm:text-[2.4rem] md:text-[2.8rem] lg:text-[3rem] leading-[3rem]">
            <span>{{ item.value.replace("+", "") }}</span><span class="text-[#19E4E0]">+</span>
          </h2>
          <p class="text-[#19E4E0] text-xs sm:text-sm">{{ item.label }}</p>
        </div>
      </div>
    </div>
  </div>
</div>